module.exports = __webpack_public_path__ + "img/Rozdzielnia zasilająca blok mieszkalny.d3afecaf.jpg";